<template>
    <section>
        <fieldset>
            <div>
                <input
                    id="postcodeLookup"
                    data-test="postcodeLookup"
                    v-model="postcode"
                    type="text"
                    class="form-control"
                    required
                />
                <button
                    v-on:click.prevent="addressLookUp"
                    class="btn btn-blue-outline mt-5 mb-4"
                    data-test="postcode-lookup-button"
                    id="postcode-lookup-button"
                >
                    Search for address
                </button>
            </div>
        </fieldset>
        <fieldset
            v-if="postCodeSearched && addressList.length > 0"
            class="py-3 postcode-lookup-addresses"
            data-test="postcode-lookup-addresses"
        >
            <label class="form-label" for="address_selection" data-test="postcode-lookup-addresses">Select your address</label>
            <select
                id="address_selection"
                v-model="selectedAddress"
                v-on:change.prevent="emitAddress"
                size="10"
                class="form-control form-select"
            >
                <option value="" selected>Please select</option>
                <option
                    :value="item.global_address_key"
                    v-for="(item, index) in addressList"
                    :key="index"
                >
                    {{ item.suggestion }}
                </option>
            </select>
        </fieldset>
        <p v-if="noResults" class="enquiry-errors" role="alert" aria-live="assertive">
            Please check and re-enter the post code for your address
        </p>
    </section>
</template>

<script setup>
import axios from "axios";
import { ref } from "vue";

const postcode = defineModel()
const addressList = ref([])
const selectedAddress = ref('')
const postCodeSearched = ref(false)
const noResults = ref(false)

const emit = defineEmits(['addressChanged'])

function addressLookUp() {
    axios
        .get(`/postcode-search?post_code=${postcode.value}`)
        .then(response => {
            const suggestions = response.data?.result?.suggestions || [];
            addressList.value = suggestions.map((item) => ({
                suggestion: item.suggestion || item.text,
                format: item.format,
                global_address_key: item.global_address_key,
            }));
            postCodeSearched.value = true;
            noResults.value = addressList.value.length === 0;
        })
        .catch(error => {
            noResults.value = true;
        });
}

function emitAddress() {
     const selectedItem = addressList.value.find(
       (item) => item.global_address_key === selectedAddress.value
        );
    if (selectedItem) {
        axios.get(
                `/postcode-search?selected_address=${encodeURIComponent(selectedItem.global_address_key)}`
            )
            .then(response => {
                emit("addressChanged", response.data);
            })
            .catch(error => {
                noResults.value = true;
                console.log(error);
            });
    }
}
</script>
